import React, { useEffect, useState } from 'react';
import Navbar from '../components/Navbar.js';
import Footer from '../components/Footer.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/pages.css';
import axios from 'axios';
import { FaChevronRight, FaCircleArrowRight } from "react-icons/fa6";
import { useNavigate, Link } from 'react-router-dom';

function Doctors() {
    const [doctors, setDoctors] = useState([]);
    const [error, setError] = useState(null);
    const [departments, setDepartments] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState('all');
    const [searchQuery, setSearchQuery] = useState('');

    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleDoctorClick = (doctor) => {
        navigate(`/doctor/${doctor.id}`, { state: { doctor } })
    };

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    const handleSearch = async () => {
        try {
            const response = await axios.get('https://caritasmathahospital.com/wp-content/themes/my_react_theme/api/get_search_doctors.php', {
                params: { query: searchQuery }
            });

            if (response.data.length === 0) {
                // No doctors found, set an error message
                setError(`No doctors found for "${searchQuery}"`);
                setDoctors([]); // Clear doctors list
            } else {
                setDoctors(response.data);
                setError(null); // Clear the error message
            }
        } catch (error) {
            console.error('Error fetching doctors:', error);
            setError('Failed to fetch doctors');
            setDoctors([]); // Clear doctors list
        }
    };



    useEffect(() => {
        fetch('https://caritasmathahospital.com/wp-content/themes/my_react_theme/api/get_departments.php')
            .then(response => response.json())
            .then(data => setDepartments(data))
            .catch(error => console.error('Error fetching departments:', error));
    }, []);

    useEffect(() => {
        const fetchDoctors = async () => {
            try {
                // Use encodeURIComponent to ensure the department name is encoded correctly
                const encodedDepartment = encodeURIComponent(selectedDepartment);
                const response = await fetch(`https://caritasmathahospital.com/wp-content/themes/my_react_theme/api/get_doctors.php?department=${encodedDepartment}`);
                const data = await response.json();
                if (Array.isArray(data)) {
                    setDoctors(data);
                    setError(null);
                } else {
                    setError('Unexpected response format');
                }
            } catch (error) {
                console.error('Error fetching doctors:', error);
                setError('Failed to fetch doctors');
            }
        };

        fetchDoctors();
    }, [selectedDepartment]);

    const handleDepartmentChange = (event) => {
        setSelectedDepartment(event.target.value);
    };

    const departmentUrlMap = {
        "Obstetrics, Gynaecology and Fetal Medicine": "/gynaecology",
        "Emergency Medicine & Trauma Care": "/emergency-medicine",
        "Paediatrics & Paediatrics Surgery": "/paediatrics-and-paediatrics-surgery",
        "Neonatology": "/neonatology",
        "General Medicine": "/general-medicine",
        "Dental, Oral & Maxillofacial Surgery": "/dental",
        "General Surgery": "/general-surgery",
        "Orthopaedics, Joint Replacement and Arthroscopy": "/orthopaedics",
        "ENT & Audiology": "/ent-audiology",
        "Plastic and Micro Vascular Surgery": "/plastic-surgery",
        "Dermatology": "/dermatology",
        "Ophthalmology": "/ophthalmology",
        "Cardiology": "/cardiology",
        "Neuro Science": "/neurology",
    };


    useEffect(() => {
        const fetchDoctors = async () => {
            try {
                const response = await fetch(`https://caritasmathahospital.com/wp-content/themes/my_react_theme/api/get_doctors.php`);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.json();
                if (Array.isArray(data)) {
                    setDoctors(data);
                    setError(null);
                } else {
                    setError('Unexpected response format');
                }
            } catch (error) {
                console.error('Error fetching doctors:', error);
                setError('Failed to fetch doctors');
            }
        };

        fetchDoctors();
    }, []);

    const groupBySpecialization = (doctors) => {
        return doctors.reduce((groups, doctor) => {
            const { specialization } = doctor;
            if (!groups[specialization]) {
                groups[specialization] = [];
            }
            groups[specialization].push(doctor);
            return groups;
        }, {});
    };

    const doctorsBySpecialization = groupBySpecialization(doctors);

    return (
        <div>
            <Navbar />

            <div className='doctors-page-section'>
                <section>
                    <p className='page-heading'>Our Doctors</p>

                    <div className="d-none d-md-block"> {/* Only works in Desktop */}
                        <p className="page-subtitle">
                            Meet Our Team of Dedicated Healthcare Professionals at
                            <br />
                            Caritas Matha Hospital.
                        </p>
                    </div>

                    <div className="d-md-none mb-2">{/* Only works in mobiles */}
                        <p className="page-subtitle">
                            Meet Our Team of Dedicated Healthcare Professionals at Caritas Matha Hospital
                        </p>
                    </div>

                </section>

                <section className='doctor-search-section'>
                    <div className="doctor-search-text">
                        <p>Find a Doctor/<br />Search Specialities</p>
                    </div>
                    <div className="doctor-search-container">
                        <input
                            type="text"
                            className="doctor-search-input"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearchChange}
                            onKeyUp={handleSearch}
                        />
                    </div>
                    <div className="department-options">
                        <select className="department-select" onChange={handleDepartmentChange}>
                            <option value="all">All Departments</option>
                            {departments.map(dept => (
                                <option key={dept.name} value={dept.name}>{dept.name}</option>
                            ))}
                        </select>
                    </div>

                </section>

                <section className='doctors-list'>
                    {error && <p>{error}</p>}
                    {Object.keys(doctorsBySpecialization).map(specialization => (
                        <div key={specialization} className="specialization-group">
                            <h3 className='doctors-dept'>{specialization}</h3>
                            <div className='doctorbox-container'>
                                {doctorsBySpecialization[specialization].map(doctor => (
                                    <div key={doctor.id} className="doctorbox">
                                        <div className="doctor-box">
                                            <img src={doctor.image_url} className='doctor-img' onClick={() => handleDoctorClick(doctor)} style={{ cursor: "pointer" }} />
                                            <div className='doctor-details'>
                                                <h4 onClick={() => handleDoctorClick(doctor)} style={{ cursor: "pointer" }}>{doctor['name']}</h4>
                                                <p>{doctor['designation']}</p>

                                                {doctor.available_time?.split('<br>').map((slot, index) => (
                                                    <div key={index}>
                                                        {/* Mobile view: break at '&' */}
                                                        <div className="doctor-avaiable-time-mobile">
                                                            {slot.split('&').map((part, i) => (
                                                                <p key={i}>
                                                                    {part.trim()}{i < slot.split('&').length - 1 && ' &'}
                                                                </p>
                                                            ))}
                                                        </div>

                                                        {/* Desktop view */}
                                                        <p className="doctor-avaiable-time">
                                                            {slot.trim()}
                                                        </p>
                                                    </div>
                                                ))}

                                                <h6 style={{ marginTop: '1rem' }}>
                                                    <Link to={departmentUrlMap[doctor.department_name] || "/"}>
                                                        {doctor.department_name}
                                                    </Link>
                                                </h6>
                                                <br />
                                                {parseInt(doctor.appointment_enabled) === 1 && (
                                                    <p>
                                                        <a href="https://booking.caritasmathahospital.com/OnlineAppointmentBooking/OnlineAppointmentBooking.aspx" target="_blank" rel="noopener noreferrer" >
                                                            Book An Appointment <FaChevronRight />
                                                        </a>
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                        <div className='arrow-section'>
                                            <FaCircleArrowRight className='right-circle-arrow' onClick={() => handleDoctorClick(doctor)} style={{ cursor: "pointer" }} />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}

                </section>
            </div>

            <Footer />
        </div>
    );
}

export default Doctors;